module.exports = __webpack_public_path__ + "media/staff/debbie-455627b5.jpg";